import { Link } from "react-router-dom";

import MainLayout from "layouts/MainLayout"

// Importing Utils
import SplashCursor from "utils/SplashCursor"
import SelectedWorkCard from "components/landing/SelectedWorkCard";
import BigCTA from "components/landing/BigCTA";

const Landing = () => {
    return (
        <>
            <div
                className={` 
                transition-opacity duration-[800ms]`
                }
            >
                <MainLayout>
                    <SplashCursor />

                    <section id="hero">
                        <div className="flex flex-col justify-center items-center h-full" style={{ height: '80vh' }}>
                            <div className="flex flex-col justify-center items-center h-full">
                                <h1 className="pt-10 pb-2 md:pb-4 text-2xl text-center font-bebasneue tracking-normal hero-text opacity-0 transition-opacity duration-1000 delay-0 animate-fade-in-1 ">SAHIR PRAJAPATI</h1>
                                <h1 className="text-6xl md:text-9xl text-center font-bebasneue tracking-tight hero-text opacity-0 transition-opacity animate-fade-in-after-1 ">DIGITAL DESIGNER</h1>

                            </div>
                        </div>
                        {/* Bottom part of the hero section */}
                        <div className="grid grid-cols-12 items-center md:py-4 pb-5 md:mt-5 inset-x-0 bottom-0 px-10">
                            <div className="col-span-12 md:col-span-10 flex gap-12 justify-center md:justify-start">
                                <Link target="_blank" to="https://www.instagram.com/zennie.visuals" className="text-lg">Instagram</Link>
                                <Link target="_blank" to="https://www.linkedin.com/in/sahirp" className="text-lg">Linkedin</Link>
                            </div>

                            <div className="md:col-span-2 flex justify-end gap-12">
                                <Link to="#" className="text-lg hidden md:block">Based out of Canada</Link>
                            </div>
                        </div>
                    </section>


                    <section id="selected-works" className="px-4 md:px-10 relative">
                        <h1 data-aos="fade-up" data-aos-duration="4000" className="mt-32 mb-16 md:mb-1 md:mt-10 text-[3rem] md:text-[5rem] text-pink-500 tracking-tight relative">Projects</h1>
                        <div className="grid md:grid-cols-1 gap-5">

                            <SelectedWorkCard
                                linkTo="/projects/cacee"
                                imgSrc="https://atypicalcms.com/assets/9da93dca-1c08-4ec7-8d46-568b7b06ba89"
                                altText="CACEE"
                                projectName="CACEE"
                                projectDescription="The conference needed a cohesive visual strategy to ensure clear, accessible, and consistent communication across digital and physical materials. I solved this by using a minimal and consistent design language that streamlined information delivery and enhanced attendee engagement in the conference and in the digital space as well."
                                textColor="blue"
                                tags={["Branding", "Marketing", "Social Media"]}
                            />

                            <SelectedWorkCard
                                linkTo="/projects/sworna"
                                imgSrc="https://atypicalcms.com/assets/bb0298bc-14da-4e62-9433-8ab48654080b"
                                altText="Sworna"
                                projectName="Sworna"
                                projectDescription="Brand kit and photography style was developed for Sworna Imitation Jewelry. The brand was centred on minimalism while heavy usage of the color red was encouraged throughout the design wherever applicable since the color has cultural relationship with jewelry."
                                textColor="red"
                                tags={["Adaptive Advertisement", "Branding", "Marketing"]}
                            />

                            <SelectedWorkCard
                                linkTo="/projects/newbalance"
                                imgSrc="https://atypicalcms.com/assets/522ba559-329a-4d5f-8ac7-cb20fe2421e4"
                                altText="New Balance"
                                projectName="New Balance"
                                projectDescription="For New Balance, creatives were focused on localizing the brand message to appeal to the local market by blending athletic functionality with modern street fashion, creating a versatile collection suitable for both sports and casual wear"
                                textColor="gray"
                                tags={["Adaptive Advertisement", "Branding", "Marketing"]}
                            />

                            <SelectedWorkCard
                                linkTo="/projects/umbro"
                                imgSrc="https://atypicalcms.com/assets/75089468-a993-4519-ab31-6f988985ae43"
                                altText="UMBRO"
                                projectName="UMBRO"
                                projectDescription="UMBRO needed to connect more deeply with Nepal’s youth by aligning its brand with the region’s growing sports culture and everyday lifestyle. I addressed this by localizing the campaign strategy; merging athletic appeal with casual wear and positioning the brand within familiar, high-traffic spaces to boost visibility and relevance."
                                textColor="orange"
                                tags={["Adaptive Advertisement", "Branding", "Marketing"]}
                            />


                            {/* <SelectedWorkCard
                                linkTo="/projects/cpt"
                                imgSrc="https://atypicalcms.com/assets/114d1ff4-8fab-465d-8bce-4f864229d37e"
                                altText="Crocus Pearl"
                                projectName="Crocus Pearl"
                                projectDescription="Crocus Pearl needed a digital presence that effectively communicated its diverse capabilities and creative edge. I solved this by designing a clear, engaging website that showcased their services, portfolio, and brand identity - positioning them as a reliable and forward-thinking marketing partner."
                                textColor="purple"
                                tags={["Website Design", "UI/UX"]}
                            /> */}
                            {/* 
                            <SelectedWorkCard
                                linkTo="/projects/ipas"
                                imgSrc="https://atypicalcms.com/assets/5820b6d4-7ecf-4a7a-9e68-ea10e2e42dee"
                                altText="IPAS Nepal"
                                projectName="IPAS Nepal"
                                projectDescription="As part of the Ipas Nepal team, I led the design of IEC materials, social media campaigns, and the visual identity for the organization. My work supported public education initiatives and advocacy efforts by ensuring accessible, consistent, and resonant communication across print, digital, and event platforms."
                                textColor="orange"
                                tags={["Branding", "Social Media", "Event Creatives"]}
                            /> */}

                        </div>
                    </section>


                    <section id="about-me" className="mb-16 md:my-20 md:mt-20 md:mb-32">
                        <h1 data-aos="fade-up" data-aos-duration="800" className="text-[3rem] md:text-[5rem] mt-32 md:mt-10 mb-10 underline md:no-underline ml-4 md:ml-9 text-pink-500 tracking-tight">Bit about me</h1>

                        <div className="flex justify-center" data-aos="fade-up" data-aos-duration="800">
                            <div className="grid px-5 md:px-10">
                                <p className="text-[2.1rem]"><span className="font-semibold">Hello, I'm<span className="text-pink-500"> Sahir, </span> a 20-something year old creative, who designs and builds websites</span>, and occasionally everything else companies wish they had thought about sooner.</p>
                                <br /><br />
                                <p className="text-[1.35rem]">While I’m often brought in to design websites, I frequently support brands beyond the screen, from identity refreshes to social media content and campaign visuals that elevate their entire digital presence.</p> <br />
                                <p className="text-[1.35rem]">While my style leans minimal and elegant, my process is guided by who you are and what your brand needs. I discuss and fully understand your direction before designing anything, whether it’s interface work, identity updates, or visuals that sharpen your marketing.
                                </p>
                                <br /><br />

                                <p className="text-[1.35rem]">Whether your project is new or evolving, I create visuals and interface that’s cohesive, intuitive, and thoughtfully built from the inside out.</p>
                            </div>
                        </div>
                    </section>

                    <section id="cts" className="hidden md:grid gap-y-10 md:grid-cols-3 md:px-40">
                        <div data-aos="fade-up" data-aos-duration="800">
                            <BigCTA
                                linkTo="mailto:info@sahirprajapati.com"
                                imageSrc="https://atypicalcms.com/assets/b2db677a-9aa5-47b1-8610-7dc1065b9053?quality=80"
                                text="Contact Me"
                            />
                        </div>
                        <div data-aos="fade-up" data-aos-duration="800" data-aos-delay="250">
                            <BigCTA
                                linkTo="/projects"
                                imageSrc="https://atypicalcms.com/assets/7f9a74a2-51cc-4050-a1f9-fa5997264c4d?quality=80"
                                text="All Projects"
                            />
                        </div>
                        <div data-aos="fade-up" data-aos-duration="800" data-aos-delay="500">
                            <BigCTA
                                linkTo="/about"
                                imageSrc="https://atypicalcms.com/assets/746f3944-3c9e-4bde-8c1d-df8c71a854bc?quality=80"
                                text="A bit more about me"
                            />
                        </div>

                        {/* Pink Logo CTAs below
                            https://atypicalcms.com/assets/73d3eab7-a49f-4c5c-a121-11f5a37b298e
                            https://atypicalcms.com/assets/f81cf287-d67a-4e9b-868d-3319fed9f5cc
                            https://atypicalcms.com/assets/5fa18dc3-7133-4923-a6e5-3629344ec16e
                         */}
                    </section>

                    <section id="cts-phone" className="grid md:hidden gap-y-10 grid-cols-3 md:px-40">
                        <div data-aos="fade-up" data-aos-duration="800">
                            <BigCTA
                                linkTo="/about"
                                imageSrc="https://atypicalcms.com/assets/746f3944-3c9e-4bde-8c1d-df8c71a854bc?quality=80"
                                text="a bit more about me"
                            />
                        </div>
                        <div data-aos="fade-up" data-aos-duration="800" data-aos-delay="250">
                            <BigCTA
                                linkTo="mailto:info@sahirprajapati.com"
                                imageSrc="https://atypicalcms.com/assets/b2db677a-9aa5-47b1-8610-7dc1065b9053?quality=80"
                                text="Contact Me"
                            />
                        </div>
                        <div data-aos="fade-up" data-aos-duration="800" data-aos-delay="500">
                            <BigCTA
                                linkTo="/projects"
                                imageSrc="https://atypicalcms.com/assets/7f9a74a2-51cc-4050-a1f9-fa5997264c4d?quality=80"
                                text="All Projects"
                            />
                        </div>
                    </section>

                </MainLayout>
            </div>
        </>
    )
}

export default Landing;